// DS5.7
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { ThemeContext, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiData } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import { URLS } from '@wix/da-url';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Logo from '@wix/da-ds/pkg/Logo';
import FooterCopyright from './FooterCopyright';
import { menuItems, socialButtons } from './constants';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import s from './SiteFooter.scss';
const CCPALink = /*#__PURE__*/ React.memo(()=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['ccpa-link']
    }, /*#__PURE__*/ React.createElement("span", {
        suppressHydrationWarning: true,
        "data-ccpa-link": "1"
    }));
}, ()=>true);
const SiteFooter = ({ className  })=>{
    const { t  } = useTranslation();
    const isMobile = useContext(MobileContext);
    const theme = useContext(ThemeContext);
    const { requiresCCPA , adsEnabled  } = useContext(SessionContext);
    const isDarkTheme = theme === ThemeOptions.DARK;
    return /*#__PURE__*/ React.createElement("footer", {
        className: classnames(s['root'], adsEnabled && s['ccpa'], className),
        role: "contentinfo"
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['columns']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['logo-column']
    }, /*#__PURE__*/ React.createElement(BiLink, {
        href: URLS.ROOT,
        title: "DeviantArt - Homepage",
        biData: BiData({
            evid: 720,
            link_name: 'logo'
        })
    }, /*#__PURE__*/ React.createElement(VisuallyHidden, null, "DeviantArt - Homepage"), /*#__PURE__*/ React.createElement(Logo, {
        markColor: isDarkTheme ? 'white' : 'black',
        textColor: isDarkTheme ? 'white' : 'black',
        size: "tiny"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['middle-column']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['multi-column']
    }, menuItems.map((item)=>/*#__PURE__*/ React.createElement("div", {
            key: item.key
        }, /*#__PURE__*/ React.createElement(BiLink, {
            href: item.href,
            title: t(item.key),
            biData: BiData({
                evid: 720,
                link_name: item.name
            })
        }, t(item.mobileKey && isMobile ? item.mobileKey : item.key)))), !isMobile && requiresCCPA && adsEnabled && /*#__PURE__*/ React.createElement(CCPALink, null))), isMobile && requiresCCPA && adsEnabled && /*#__PURE__*/ React.createElement(CCPALink, null), /*#__PURE__*/ React.createElement("div", {
        className: s['social-column']
    }, socialButtons.map((sb, index)=>/*#__PURE__*/ React.createElement(BiLink, {
            key: index,
            className: s['social-item'],
            href: sb.href,
            title: sb.title,
            biData: BiData({
                evid: 720,
                link_name: sb.name
            })
        }, /*#__PURE__*/ React.createElement(VisuallyHidden, null, sb.title), /*#__PURE__*/ React.createElement(sb.icon, {
            size: IconSize.MEDIUM,
            disableDefaultColors: true
        })))), isMobile && /*#__PURE__*/ React.createElement(FooterCopyright, {
        className: s['copyright']
    })), !isMobile && /*#__PURE__*/ React.createElement(FooterCopyright, {
        className: s['copyright']
    }));
};
SiteFooter.displayName = 'SiteFooter';
export default /*#__PURE__*/ React.memo(SiteFooter);
